var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _rect3, _path10, _path11, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtensionchrome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: "40px",
    height: "40px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M38.5,20c0,10.216-8.284,18.5-18.5,18.5S1.5,30.216,1.5,20S9.784,1.5,20,1.5S38.5,9.784,38.5,20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M20,1.5V20l7.4,3.7l-8.18,14.8c0.293,0,0.487,0,0.78,0c10.224,0,18.5-8.276,18.5-18.5 S30.224,1.5,20,1.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b6dcfe",
    d: "M38.5,20c0,10.216-8.284,18.5-18.5,18.5S1.5,30.216,1.5,20S9.784,1.5,20,1.5S38.5,9.784,38.5,20z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#dff0fe",
    d: "M20,1.5V20l7,3.7l-8.18,14.8c0.293,0,0.887,0,1.18,0c10.224,0,18.5-8.276,18.5-18.5 S30.224,1.5,20,1.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#b6dcfe",
    d: "M36.502,11.675L37,12H20v11.7l-2.775-0.925c0,0-12.47-13.241-12.398-13.344 C8.161,4.635,13.715,1.5,20,1.5C27.215,1.5,33.459,5.644,36.502,11.675z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#98ccfd",
    d: "M5.125,8.6l8.18,13.747l4.624-1.042L5.125,8.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#98ccfd",
    d: "M18.434,38.5l8.264-14.855l-3.784-2.72L18.434,38.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#b6dcfe",
    d: "M36.525,13H20l-1.461,4.236L36.525,13z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4788c7",
    d: "M20,39C9.523,39,1,30.477,1,20S9.523,1,20,1s19,8.523,19,19S30.477,39,20,39z M20,2 C10.075,2,2,10.075,2,20s8.075,18,18,18s18-8.075,18-18S29.925,2,20,2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16.873,
    height: 1,
    x: 20.25,
    y: 12,
    fill: "#4788c7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.999,
    height: 17.895,
    x: 22.354,
    y: 21.925,
    fill: "#4788c7",
    transform: "rotate(26.967 22.852 30.87)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16.971,
    height: 1,
    x: 0.944,
    y: 16.099,
    fill: "#4788c7",
    transform: "rotate(60 9.43 16.599)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20,27.5c-4.136,0-7.5-3.364-7.5-7.5s3.364-7.5,7.5-7.5s7.5,3.364,7.5,7.5S24.136,27.5,20,27.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#4788c7",
    d: "M20,13c3.86,0,7,3.14,7,7s-3.14,7-7,7s-7-3.14-7-7S16.14,13,20,13 M20,12c-4.417,0-8,3.583-8,8 s3.583,8,8,8s8-3.583,8-8S24.417,12,20,12L20,12z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#98ccfd",
    d: "M20,25.5c-3.033,0-5.5-2.468-5.5-5.5s2.467-5.5,5.5-5.5s5.5,2.468,5.5,5.5S23.033,25.5,20,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20,15c2.757,0,5,2.243,5,5s-2.243,5-5,5s-5-2.243-5-5S17.243,15,20,15 M20,14c-3.315,0-6,2.685-6,6 s2.685,6,6,6s6-2.685,6-6S23.315,14,20,14L20,14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensionchrome);
export default __webpack_public_path__ + "static/media/Extensionchrome.07e8a87b9406f9a881b3acc6c9d4129b.svg";
export { ForwardRef as ReactComponent };